import React from 'react';
import GenAiReveal from './GenAiReveal';
import { GEN_AI_CREATIVE_LANDING } from '../../data/genAiCreativeLanding';

const GenAiTrust = () => {
  const { trust } = GEN_AI_CREATIVE_LANDING;
  const items = [...trust.logos, ...trust.logos, ...trust.logos];

  return (
    <section className="overflow-hidden bg-white px-5 py-16 md:px-10 md:py-20 xl:px-[100px] xl:py-[110px]">
      <div className="mx-auto max-w-[1240px]">
        <GenAiReveal>
          <h2 className="text-center text-[32px] font-bold leading-none text-[#0b0b0b] md:text-4xl xl:text-[48px]">
            {trust.title}
          </h2>
        </GenAiReveal>

        <div className="relative mt-12 overflow-hidden">
          <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-12 bg-gradient-to-r from-white to-transparent md:w-24" />
          <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-12 bg-gradient-to-l from-white to-transparent md:w-24" />
          <div className="gen-ai-trust-marquee flex w-max gap-4 md:gap-6">
            {items.map((logo, index) => (
              <div
                key={`${logo.name}-${index}`}
                className="flex h-[66px] shrink-0 items-center justify-center rounded-2xl border border-[#e5e4ec] bg-[#ecebf2] px-9"
              >
                <span className="whitespace-nowrap text-lg font-semibold text-[#0b0b0b]/70 md:text-xl">
                  {logo.name}
                </span>
              </div>
            ))}
          </div>
        </div>

        <p className="mt-10 text-center text-base text-[#2f2f2f]/80 md:text-lg">
          {trust.note}
        </p>
      </div>
    </section>
  );
};

export default GenAiTrust;
